/** Where the Remotion player actually draws the composition inside its
 *  container ("contain" fit, centered): the canvas-editor overlay must cover
 *  exactly this box, or selection rects drift off the rendered media
 *  whenever the composition aspect differs from the container's (e.g. a
 *  9:16 composition pillarboxed inside the 16:9 preview wrapper). */
export function computeCompositionFitBox(
  { containerWidth, containerHeight, compAspect }:
  { containerWidth: number; containerHeight: number; compAspect: number },
): { left: number; top: number; width: number; height: number } {
  if (!Number.isFinite(compAspect) || compAspect <= 0 || containerWidth <= 0 || containerHeight <= 0) {
    return { left: 0, top: 0, width: containerWidth, height: containerHeight };
  }
  const containerAspect = containerWidth / containerHeight;
  if (compAspect < containerAspect) {
    const width = containerHeight * compAspect;
    return { left: (containerWidth - width) / 2, top: 0, width, height: containerHeight };
  }
  const height = containerWidth / compAspect;
  return { left: 0, top: (containerHeight - height) / 2, width: containerWidth, height };
}
